
import {Component, Vue} from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import TakipAltTipForm from "@/components/forms/TakipAltTipForm.vue";

import {TakipAltTipiEntity} from "@/entity/TakipAltTipiEntity";

@Component({
  components: {FormDialog, DeleteDialog, TakipAltTipForm},
})
export default class TakipAltTipList extends Vue {
  items = [];

  headers = [
    {text: "Takip Alt Tip Adı", align: "start", sortable: false, value: "isim"},
    {text: "Takip Tip", align: "start", sortable: false, value: "takip_tipi"},
    {text: "İşlemler", value: "actions", width: 100, sortable: false, align: 'end'},
  ];

  mounted() {
    this.loadTakipAltTip();
  }

  loadTakipAltTip() {
    this.$http.get("/api/v1/takip-alt-tipi-list").then((response) => {
      this.items = response.data;
    });
  }

  createTakipAltTipHesapAyar() {
    this.loadTakipAltTip();
  }

  updateTakipAltTip(data: any) {
    this.$http.put(`/api/v1/takip-alt-tipi/${data.id}`, data).then(() => {
      this.loadTakipAltTip();
    });
  }

  detay(item: TakipAltTipiEntity) {
    this.$router.push("takip-alt-tip/" + item.id!.toString());
  }
}
